import { Benefit, State } from '@witkac/kartamiejska-shared';
import { BenefitResource, benefitResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Moduł partnerów
 *
 * @export
 * @class BenefitModule
 * @extends {EntityModule<Benefit, BenefitResource>}
 */
export class BenefitModule extends EntityModule<Benefit, BenefitResource> {
  constructor() {
    super(benefitResource);
    this.actions = {
      ...this.actions,
      /**
       * Listowanie benefitów z domyślnym filtrowaniem
       *
       * @param {*} context
       * @param {*} filters
       * @returns {Promise<void>}
       */
      list: async (context: any, filters: any): Promise<void> => {
        const { list, count } = await this.resource.list({ upToDate: true, state: State[State.ACTIVE], ...filters });
        context.commit('saveList', list);
        context.commit('saveCount', count);
      }
    };
  }
}

export default new BenefitModule();
